module.exports = __webpack_public_path__ + "media/autopilot-hero.978f3de3.mp4";